import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-23391bc0"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "iconList"
};

const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "每日推荐", -1));

const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "私人FM", -1));

const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "歌单", -1));

const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "排行榜", -1));

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_van_icon = _resolveComponent("van-icon");

  const _component_van_tabbar_item = _resolveComponent("van-tabbar-item");

  const _component_van_tabbar = _resolveComponent("van-tabbar");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_van_tabbar, {
    fixed: false,
    border: false
  }, {
    default: _withCtx(() => [_createVNode(_component_van_tabbar_item, null, {
      icon: _withCtx(() => [_createVNode(_component_van_icon, {
        class: "iconfont",
        "class-prefix": "icon",
        name: "rili"
      })]),
      default: _withCtx(() => [_hoisted_2]),
      _: 1
    }), _createVNode(_component_van_tabbar_item, null, {
      icon: _withCtx(() => [_createVNode(_component_van_icon, {
        class: "iconfont",
        "class-prefix": "icon",
        name: "shouyinji"
      })]),
      default: _withCtx(() => [_hoisted_3]),
      _: 1
    }), _createVNode(_component_van_tabbar_item, null, {
      icon: _withCtx(() => [_createVNode(_component_van_icon, {
        class: "iconfont setclass",
        "class-prefix": "icon",
        name: "gedan"
      })]),
      default: _withCtx(() => [_hoisted_4]),
      _: 1
    }), _createVNode(_component_van_tabbar_item, null, {
      icon: _withCtx(() => [_createVNode(_component_van_icon, {
        class: "iconfont",
        "class-prefix": "icon",
        name: "PCbofangye_paihangbang"
      })]),
      default: _withCtx(() => [_hoisted_5]),
      _: 1
    })]),
    _: 1
  })]);
}